import React from "react";
export default function DataCompliances(){
  return(
    <>
    <section className="data-complian-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4">
            <div className="data-complian-box">
              <img src="/assets/images/data-compilance-icon-1.webp" alt="icon" />
              <span>Data privacy and protection</span>
            </div>
          </div>

          <div className="col-lg-4 col-md-4">
            <div className="data-complian-box">
              <img src="/assets/images/data-compilance-icon-2.webp" alt="icon" />
              <span>Compliance standards alignment</span>
            </div>
          </div>

          <div className="col-lg-4 col-md-4">
            <div className="data-complian-box">
              <img src="/assets/images/data-compilance-icon-3.webp" alt="icon" />
              <span>Regulatory management</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}